import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap'
import { withRouter } from "react-router-dom";
import Api from './Api'

const FETCH_URL = 'api/auth/token'

class Login extends Component {
    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            Email: '',
            Password: '',
            Errors: {}
        };
    }
    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();

        var data = {
            username: this.state.Email,
            password: this.state.Password
        }

        Api.PostApiWithoutThen(FETCH_URL, data, this.props.history)
            .then(response => {
                Api.print('Login response')
                Api.print(response)

                if (response !== undefined) {
                    Api.print(response.status)
                    switch (response.status) {
                        case 200:
                            Api.print('Login 200')
                            this.setState({ Errors: {} })
                            response.json()
                                .then(data => {
                                    Api.print('Then 200')
                                    Api.setIsAdmin(data.admin)
                                    Api.setRoles({ memberRole: data.memberRole, adminRole: data.adminRole, secretaryManagementRole: data.secretaryManagementRole, secretaryViewRole: data.secretaryViewRole })
                                    Api.setSession(data.token, data.expiration, data.firstname, data.mail)
                                    this.props.fnc(
                                        <div>
                                            <LinkContainer exact to={Api.isAdmin() ? "/admin" : "/account/beheren"}>
                                                <Button className="top-menu-btn" bsStyle="default">Hallo {response.firstname}</Button>
                                            </LinkContainer>
                                            <LinkContainer exact to="/account" onClick={() => this.handleClick()}>
                                                <Button className="top-menu-btn" bsStyle="default">Uitloggen</Button>
                                            </LinkContainer>
                                        </div>)
                                    if (Api.isAdmin()) {
                                        this.props.history.push('/admin')
                                    } else {
                                        this.props.history.push('/account/beheren')
                                    }
                                })
                            break
                        case 400:
                            Api.print('Login 400')
                            response.json()
                                .then(data => {
                                    Api.print('Then 400')
                                    this.setState({ Errors: data })

                                })
                            break
                        case 401:
                            this.setState({ Errors: { login: "De inloggegevens zijn niet correct" } })
                            break
                        default:
                            // TODO: Show a message
                            this.setState({ Errors: { login: "The form could not be sent" } })
                            break
                    }
                }
            })
    }

    render() {
        return (
            <div className="Login">
                <h4>Inloggen</h4>
                <hr />
                <Form horizontal onSubmit={this.handleSubmit}>
                    <FormGroup controlId="formHorizontalLoginEmail">
                        <Col componentClass={ControlLabel} sm={2}>
                            E-mailadres
                        </Col>
                        <Col sm={6}>
                            <FormControl name='Email' type="email" placeholder="Email" onChange={this.handleChange} />
                            {Api.showError(this.state.Errors, 'userName')}
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="formHorizontalLoginPassword">
                        <Col componentClass={ControlLabel} sm={2}>
                            Wachtwoord
                        </Col>
                        <Col sm={6}>
                            <FormControl name='Password' type="password" placeholder="Password" onChange={this.handleChange} />
                            {Api.showError(this.state.Errors, 'password')}
                            {Api.showError(this.state.Errors, 'login')}
                        </Col>
                    </FormGroup>

                    {/**<FormGroup>
                            <Col smOffset={2} sm={6}>
                                <Checkbox>Onthoud mij</Checkbox>
                            </Col>
                        </FormGroup>**/}

                    <FormGroup>
                        <Col smOffset={2} sm={6}>
                            <Button className='btn btn-default' type='submit'>Inloggen</Button> <p style={{ color: 'red' }}>{this.state.Error}</p>
                        </Col>
                    </FormGroup>


                </Form>
            </div>
        );
    }
}

export default withRouter(Login);


// WEBPACK FOOTER //
// ./src/components/Global/Modules/Login.js